import { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IPurchaseEnquiryFields, IDetailList } from "../../purchaseEnquiryType"
import { purchaseEnquiryService } from "../../purchaseEnquiryService"
import { transPgToPagination, formatNum, IsUseDefaultBentity, momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { supplierMapModel, supplierMapType } from "@/utils/supplierMap";
import { useLockFn } from "ahooks";
import { message } from "antd";
import moment from "moment";
export type IPreviewInfoType = {
    visible: boolean,
    md5: string,
    fileName: string,
    filePath: string
    fileType: string
}
export const usePurchaseEnquiryDetailsModel = createModel(function () {
    const { user, supplieAllList, shopAndOrg, beShopDs, setLoadingInfo } = useGlobalModel()
    const { shopId, shopName, shopCode } = shopAndOrg
    const { supplierMap } = supplierMapModel();
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initForm = {
        shopId, shopName,
        // endTime: moment(new Date()),
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
        type: 'Inquiry-type.001',
        sendType: 'note',
        // supplierList: supplieAllList.map((item: any) => { return { code: item.code, name: item.name, type: item.typeCode } })
    }
    const returnList: any = {
        //配件厂家
        'approval-type.001': 'supplier-type.material',
        //辅油厂家
        'approval-type.002': 'supplier-type.002',
        //轮胎厂家
        'approval-type.003': 'supplier-type.001',
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchaseEnquiryFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchaseEnquiryFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    //查看详情列表
    const [detailSupplierList, setDetailSupplierList] = useState<any[]>([])
    //供应商列表
    // const [supplierList, setSupplierList] = useState<any[]>([]);
    //供应商列表弹窗
    const [addSupplierVisible, setAddSupplierVisible] = useState<boolean>(false);
    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchaseEnquiryFields>({})

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<any[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<any[]>([]);
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    //supplierMap过滤supplierInfo
    const [supplier, setSupplier] = useState<supplierMapType[]>([]);
    //更换供应商弹窗
    const [changeSupplierVisible, setChangeSupplierVisible] = useState<boolean>(false);
    const [selectSupplier, setSelectSupplier] = useState<any>({});
    const [changeSupplierLogData, setChangeSupplierLogData] = useState<supplierMapType[]>([]);
    const typeForm: any = {
        add: { ...detailAddForm, shopId, shopCode, shopName },
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //新增表单缓存
    const updateAddFormVal = (val: IPurchaseEnquiryFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchaseEnquiryFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchaseEnquiryService.one(id);
        if (retData) {
            const { details, supplierInfo, ...from } = retData
            if (retData) {
                let fileList: any = []
                const { md5, fileName } = from
                if (md5) {
                    fileList = [
                        {
                            uid: md5,
                            status: 'done',
                            name: fileName,
                            response: {
                                retData: md5,
                            },
                        },
                    ]
                }
                from.fileList = fileList

                const supplier = supplierMap.filter(e => supplierInfo.indexOf(e.code) > -1);
                setSupplier(supplier);

                const list = details?.map((item: any) => {
                    //处理供应商控制价、含税单价、交货期、产地等字段
                    const supplierColumns: any = {}
                    supplier.forEach(e => {
                        const detail = item.details?.filter((item: any) => item.supplierCode === e.code)[0];
                        supplierColumns[`${e.idx}ControlPrice`] = detail?.controlPrice;
                        supplierColumns[`${e.idx}OfferPrice`] = detail?.offerPrice;
                        supplierColumns[`${e.idx}DeliveryTime`] = detail?.deliveryTime;
                        supplierColumns[`${e.idx}ProducingArea`] = detail?.producingArea;
                        supplierColumns[`${e.idx}TotalScore`] = detail?.totalScore;
                    })
                    return { ...item, ...supplierColumns }
                })
                let newSupplierInfo: any = supplierInfo.split(',')
                let newList: any = []
                supplieAllList.map((item: any) => {
                    if (newSupplierInfo.includes(item.code)) {
                        newList.push({ userCode: item.userCode, code: item.code, name: item.name, type: item.typeCode })
                    }
                })
                console.log(newList);
                debugger
                if (pattern === "edit") {
                    setDetailDataSource(list ?? [])
                    setDetailEditForm({
                        ...from,
                        endTime: from.endTime ? moment(from.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                        sendTimes: from.sendTime ? momentFormat(from.sendTime) : null,
                        updateTimes: from.updateTime ? momentFormat(from.updateTime) : null,
                        supplierList: newList,
                        approvalTimes: from.approvalTime ? momentFormat(from.approvalTime) : null,
                        sendTime: from.sendTime ? momentFormat(from.sendTime) : null,
                    })
                    setTopButsControl(false)
                } else if (pattern === "look") {
                    setDetailLookForm({
                        ...from,
                        endTime: from.endTime ? moment(from.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                        sendTimes: from.sendTime ? momentFormat(from.sendTime) : null,
                        updateTimes: from.updateTime ? momentFormat(from.updateTime) : null,
                        supplierList: newList,
                        approvalTimes: from.approvalTime ? momentFormat(from.approvalTime) : null,
                        sendTime: from.sendTime ? momentFormat(from.sendTime) : null,
                    });
                    setDetailLookList(list ?? [])
                }

                // setSupplierList(newList)
                if (from.status !== "purchase_enquiry.init") {
                    let { retData: supplierretData } = await purchaseEnquiryService.oneSupplier(from.code);
                    setDetailSupplierList(supplierretData)
                    let { retData: changeSupplierLog } = await purchaseEnquiryService.changeSupplierLog({
                        pageSize: -1,
                        pageNum: 1,
                        code: from.code
                    });
                    setChangeSupplierLogData(changeSupplierLog.records)
                }
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    const [addLoading, setAddLoading] = useState<boolean>(false)
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        setAddLoading(true)
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            let { latestPurPrice, materialDetal, materialShelfVo } = item
            let materialOne = (materialDetal ?? [])[0]
            materialShelfVo = materialShelfVo ?? {}
            //取最近采购价格，没有的话取档案进货价
            let purchasePrice = !!latestPurPrice ? latestPurPrice : materialOne?.purchasePrice ?? 0;
            return {
                ...item,
                num: 1,
                controlPrice: purchasePrice
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
        setAddLoading(false)
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: any[], detailList: IDetailList[], mode: string) => {
        const repetition: string[] = [];
        const newDetailData: any[] = [...detailList]
        modelList?.forEach(Item => {
            let isSelect = newDetailData.find(item => item.materialCode === (Item.materialCode ?? Item.code));
            let newData: any = {}
            typeForm[mode].approveTypeCode == 'approval-type.001' &&
                typeForm[mode]?.supplierList?.map((list: any) => {
                    newData[`${list.userCode}ControlPrice`] = 0
                })
            if (isSelect === undefined) {
                newDetailData.push({
                    // ...Item,
                    id: "",
                    materialCode: Item.materialCode ?? Item.code,
                    materialName: Item.materialName ?? Item.name,
                    model: Item.model,
                    unitName: Item.unitName,
                    vehicleModel: Item.vehicleModel,
                    upperClothBrand: Item.upperClothBrand,
                    chassisBrand: Item.chassisBrand,
                    unitCode: Item.unitCode,
                    num: Item.num,
                    controlPrice: 0,
                    ...newData,
                    producingArea: Item.producingArea,
                    price: typeForm[mode].approveTypeCode == 'approval-type.001' ? 0 : '',
                    deliveryTime: typeForm[mode].approveTypeCode == 'approval-type.001' ? 0 : '',
                    details: typeForm[mode].approveTypeCode == 'approval-type.001' ? typeForm[mode]?.supplierList?.map((list: any) => {
                        return {
                            id: '', // 生成一个随机 ID
                            supplierCode: list.code,
                            supplierName: list.name,
                            materialCode: Item.materialCode ?? Item.code,
                            materialName: Item.materialName ?? Item.name,
                            controlPrice: 0
                        }
                    }) : []
                });
            } else {
                repetition.push(`【${Item.materialName ?? Item.name} (${Item.materialCode ?? Item.code})】`);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode)
            setDetailAddList([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        } else if (mode === "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode)
            setDetailDataSource([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        let newRowKeys = mode === 'add' ? detaiAddDataRowKeys : detailDataRowKeys
        const filterDetailList = Material ? newData.filter(el => !!!(Material.materialCode === el.materialCode)) : newData.filter(el => !!!newRowKeys.find(ele => ele === el.materialCode));
        mode === "edit" ? setDetailDataSource([...filterDetailList]) : setDetailAddList([...filterDetailList])
        globalPrompt("message", { text: `删除成功`, type: "success" });
        setDetaiAddDataRowKeys([]);
        setDetaiAddDataRow([]);
        setTopButsControl(true)
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchaseEnquiryFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseEnquiryService.insert(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchaseEnquiryFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseEnquiryService.update(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    const verifyGoods = (mode: string): boolean => {
        let goods = mode === 'edit' ? detailDataSource : detailAddList;
        if (!goods.length) {
            message.warning('请添加商品明细');
            return false;
        }
        // 第一个筛选：筛选 num 为 0 的对象
        const filterByNum = goods.filter(item => item.num === 0).map(list => list.materialName)
        if (filterByNum.length > 0) {
            message.warning(`请完善${filterByNum}的采购数量`);
            return false;
        }
        // // 第二个筛选：筛选 details 中所有 controlPrice 都为 0 的对象
        // const filterByControlPrice = goods.filter(item => {
        //     if (item.details.find((detail: any) => !detail.controlPrice&&)) {
        //         return true
        //     }
        //     return false;
        // }).map(list => list.materialName)
        // if (filterByControlPrice.length > 0) {
        //     message.warning(`请完善${filterByControlPrice}的供应商详情的控制价格`);
        //     return false;
        // }
        // 第一个筛选：筛选 num 为 0 的对象
        const typeFind = goods.filter(item => item.price === 0 || !item.supplierName).map(list => list.materialName)
        if (typeFind.length > 0 && typeForm[mode].approveTypeCode !== 'approval-type.001') {
            message.warning(`轮胎，辅油审批发布前，请填写选中供应商的信息！`);
            return false;
        }
        return true;
    };
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm(initForm)
        setDetailAddList([]);
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    const downloadTpl = async () => {
        let result = await purchaseEnquiryService.downloadTpl();
        convertRes2Blob(result)
    }
    const Submit = useLockFn(async () => {
        let { retData } = await purchaseEnquiryService.submit(detailEditForm.id as string);
        return retData
    })
    const Transfer = useLockFn(async (val) => {
        let { retData } = await purchaseEnquiryService.transfer({
            id: detailEditForm.id,
            status: val
        });
        return retData
    })
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [supplierHistoryVisible, setSupplierHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [supplierHistoryModel, setSupplierHistoryModel] = useState<{ supplierName: string }>({ supplierName: "" }) //消费记录参数

    //详情导出
    const exportPurchaseEnquiryDetail = async (code: string) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        try {
            let result = detailEditForm.approveTypeCode == 'approval-type.001' ? await purchaseEnquiryService.exportDetail(code) : await purchaseEnquiryService.ltFyExport(code);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }

    return {
        addModalVisible, addLoading,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detaiAddDataRowKeys,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        Transfer,
        Submit,
        returnList,
        supplier, setSupplier,
        initForm, verifyGoods,
        topButsControl, setTopButsControl,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        supplierHistoryVisible, setSupplierHistoryVisible,
        supplierHistoryModel, setSupplierHistoryModel,
        saveLoading, setSaveLoading,
        // supplierList, setSupplierList,
        addSupplierVisible, setAddSupplierVisible,
        detailSupplierList, setDetailSupplierList,
        exportPurchaseEnquiryDetail,
        changeSupplierVisible, setChangeSupplierVisible,
        selectSupplier, setSelectSupplier,
        changeSupplierLogData, setChangeSupplierLogData
    }
})